export const LanguageEnum = [
  {
    value: 1,
    code: 'en',
    name: 'English',
    labelFrench: 'Anglais',
    labelEnglish: 'English',
    order: 2,
  },
  {
    value: 2,
    code: 'fr',
    name: 'French',
    labelFrench: 'Français',
    labelEnglish: 'French',
    order: 1,
  },
  {
    value: 3,
    code: '',
    name: 'Other',
    labelFrench: 'Autre',
    labelEnglish: 'Other',
    order: 3,
  },
];

export const LanguageEnumValue = {
  FRENCH: 2,
  ENGLISH: 1,
  OTHER: 3,
};

export const LanguageValue = {
  FRENCH: 'cf1739b5-7b7f-409d-92a7-a33e4d20e97c',
  ENGLISH: 'ab75ccf5-bee7-4631-beef-0b43043381dd',
};

export default LanguageEnum;
